const INTAKE_API = {
    getSuppliers: "/Intake/Suppliers",
    getStatus: "/Intake/Status",
    getClaims: "/claims",
    batchIntake: "/Intake/Intake",
    getBatchIntake: "Intake/Intakes",
    deleteBatchIntake: "Intake/Intakes",
    suppliersStats: "/suppliersStats",
    saleStats: "/saleStats",
    batchesStats: "/batchesStats",
    getProducts: "/Intake/Products",
    getProductsSize: "/Intake/ProductSize",
    getProductsQuality: "/Intake/ProductQuality",
    getLocations: "/Locations",
    getTopSupplier: "/Statistics/TopPerformingSupplier",
    getSupplierCompliance: "/Statistics/SupplierCompliance",
    getIntakeVolume: "/Statistics/IntakeVolumeProcessed",
    getTotalSaleRevenue: "/Statistics/TotalSalesRevenue",
    getProfitMargin: "/Statistics/ProfitMargin",
    addSupplier: "/Intake/Supplier",
    addProduct: "/Intake/Product",

  };
  
  export default INTAKE_API;
  